// extracted by css-extract-rspack-plugin
export default {"option":"_f4019541","optionBackdrop":"_4a879d23","optionHighlight":"_4f153cf1","optionDisabled":"_a9baf431","optionSelected":"_c108a468"};